import { render } from "./SocialAccounts.vue?vue&type=template&id=69dadbe6&scoped=true"
import script from "./SocialAccounts.vue?vue&type=script&lang=js"
export * from "./SocialAccounts.vue?vue&type=script&lang=js"

import "./SocialAccounts.vue?vue&type=style&index=0&id=69dadbe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69dadbe6"]])

export default __exports__